<template>
  <div class="ovop-explore-china">
    <div class="title">
      全国地方特色商品
      <div class="split"></div>
      <div class="link" @click="onClick">查看全部商品 ></div>
    </div>
    <el-row :gutter="0">
      <el-col :span="4" class="block">
        <h2 @click="selectDataSource('寻源商品')">{{explore.onlineCount}}</h2>
        <div>寻源商品数</div>
      </el-col>
      <el-col :span="1">
        <div class="divider"></div>
      </el-col>
      <el-col :span="4" class="block">
        <h2 @click="selectDataSource('引入商品')">{{explore.importCount}}</h2>
        <div>引入商品数</div>
      </el-col>
      <el-col :span="1">
        <div class="divider"></div>
      </el-col>
      <el-col :span="4" class="block">
        <h2 @click="selectDataSource('地标商品')">{{explore.iconicCount}}</h2>
        <div>地标性商品</div>
      </el-col>
      <el-col :span="1">
        <div class="divider"></div>
      </el-col>
      <el-col :span="4" class="block">
        <h2 style="color:#999">{{explore.provinceCount}}</h2>
        <div>覆盖省区数</div>
      </el-col>
      <el-col :span="1">
        <div class="divider"></div>
      </el-col>
      <el-col :span="4" class="block">
        <h2 style="color:#999">{{explore.cityCount}}</h2>
        <div>覆盖市县数</div>
      </el-col>
    </el-row>
    <img src="@/assets/插图.png" alt />
  </div>
</template>

<script>
export default {
  name: "OvopExploreChinaDashboard",
  props: ["explore"],
  methods: {
    onClick() {
      this.$router.push("/ovop/list");
    },
    selectDataSource(e) {
      this.$emit("change", e);
    }
  }
};
</script>

<style lang="less" scoped>
.ovop-explore-china {
  position: relative;

  .title {
    font-size: 32px;
    color: #333;
    font-weight: 600;

    padding: 25px 40px;
    line-height: 42px;

    .split {
      width: 1px;
      height: 16px;
      background: #ccc;
      display: inline-block;
      // margin: 10px;
      margin: 0 15px;
    }

    .link {
      display: inline-block;
      font-size: 18px;
      font-weight: 400;
      color: rgba(64, 177, 93, 1);
      line-height: 25px;
      cursor: pointer;
    }
  }

  img {
    position: absolute;
    right: 0;
    bottom: 0;

    height: 200px;
  }

  .divider {
    width: 1px;
    margin: 20px auto;
    height: 50px;
    background: rgba(244, 244, 244, 1);
  }

  .el-row {
    width: 800px;
    padding: 20px 0;
  }

  h2 {
    font-size: 30px;
    font-weight: 500;
    color: rgba(27, 153, 79, 1);
    text-align: center;
    font-family: "DIN Medium";

    cursor: pointer;
  }

  .block {
    height: 20px;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    // padding: 20px 0;

    img {
      width: 20px;

      vertical-align: top;
      margin-right: 5px;
    }
  }
}
</style>